import { getLocalStorage } from './storage'

import { getNumberOfDays } from './date'

import {
  DV_360_PROVIDER_PLATFORM,
  FACEBOOK_PROVIDER_PLATFORM,
  GOOGLE_PROVIDER_PLATFORM,
  TIKTOK_PROVIDER_PLATFORM
} from '../constants/selectLists/platformList'
import { defaultLocale, LANGUAGE } from '../constants/language'

import {
  BUDGET_LIFETIME,
  BUDGET_LIFETIME_LINE_ITEM
} from '../forms/Multiplatform/CombinedFacebookTiktokCreate/CreateFormSelector/CampaignCreateForm/fields'
import { BUDGET_DAILY } from '../forms/Multiplatform/CampaignForms/fields'

export const getSelectedLanguage = () => getLocalStorage(LANGUAGE) || defaultLocale

export const BRAND_PRIMARY_COLOR = 'brandPrimary'
export const BRAND_PRIMARY_LIGHT_COLOR = 'brandPrimaryLight'

export const initialThemeColor = null

export const getPartnershipColors = partnershipData => {
  const partnershipBrandColor = partnershipData && partnershipData['brand_colour']
  const partnershipBrandColorLight = partnershipData && partnershipData['brand_colour_light']

  if (partnershipBrandColor || partnershipBrandColorLight) {
    // when there is some custom color related to partnership
    return {
      [BRAND_PRIMARY_COLOR]: partnershipBrandColor,
      [BRAND_PRIMARY_LIGHT_COLOR]: partnershipBrandColorLight
    }
  } else {
    return initialThemeColor
  }
}

export const getTotalBudgetInDigitalRight = allCampaignsInDigitalRight => {
  const facebookCampaigns = allCampaignsInDigitalRight.filter(
    campaign => campaign.provider === FACEBOOK_PROVIDER_PLATFORM
  )
  const googleCampaigns = allCampaignsInDigitalRight.filter(campaign => campaign.provider === GOOGLE_PROVIDER_PLATFORM)

  const tikTokCampaigns = allCampaignsInDigitalRight.filter(campaign => campaign.provider === TIKTOK_PROVIDER_PLATFORM)

  const dv360Campaigns = allCampaignsInDigitalRight.filter(campaign => campaign.provider === DV_360_PROVIDER_PLATFORM)

  const totalFacebookCampaignsBudget = facebookCampaigns.reduce((partialSum, campaign) => {
    const budget = campaign[BUDGET_LIFETIME] || campaign[BUDGET_LIFETIME_LINE_ITEM] || 0
    return partialSum + Number(budget)
  }, 0)

  const totalGoogleCampaignsBudget = googleCampaigns
    .filter(item => item.status !== 'deleted')
    .reduce((partialSum, campaign) => {
      const dateStart = campaign.date_start
      const dateStop = campaign.date_stop
      // Newly created campaign has different budget field in redux store:
      // campaign.campaign_budget.amount_micros
      const budgetDaily = campaign[BUDGET_DAILY] || campaign?.campaign_budget?.amount_micros

      const days = getNumberOfDays(dateStart, dateStop)

      const budgetLifetime = days * budgetDaily

      return partialSum + Number(budgetLifetime)
    }, 0)

  const totalTikTokCampaignsBudget = tikTokCampaigns.reduce((partialSum, campaign) => {
    const budget = campaign.budget || campaign[BUDGET_LIFETIME_LINE_ITEM] || 0
    return partialSum + Number(budget)
  }, 0)

  const totalDV360CampaignsBudget = dv360Campaigns.reduce((partialSum, campaign) => {
    const budget = campaign[BUDGET_LIFETIME] || 0
    return partialSum + Number(budget)
  }, 0)

  return (
    totalFacebookCampaignsBudget + totalGoogleCampaignsBudget + totalTikTokCampaignsBudget + totalDV360CampaignsBudget
  )
}

export const downloadCSVFile = ({ data, fileName }) => {
  const url = window.URL.createObjectURL(new Blob([data]))
  downloadFileByBrowser({ url, fileName, fileFormat: 'csv' })
}

export const downloadFileByBrowser = ({ url, fileName, fileFormat }) => {
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', `${fileName}.${fileFormat}`)
  document.body.appendChild(link)
  link.click()
  link.remove()
}
